import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../../assets/coupon/down.png'
import _imports_1 from '../../assets/coupon/dyhmxd.png'


const _hoisted_1 = { class: "page_cjdyp" }
const _hoisted_2 = { class: "banner_img" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "bannerMargin" }, null, -1)
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "leftImg anima",
  style: {"width":"25%"}
}, null, -1)
const _hoisted_6 = { style: {"letter-spacing":"-2px","width":"20%","text-align":"center"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "moneyIcon" }, "￥", -1)
const _hoisted_8 = { class: "moneyNumber" }
const _hoisted_9 = {
  class: "rightContent",
  style: {"width":"55%"}
}
const _hoisted_10 = { class: "couponTitle" }
const _hoisted_11 = { class: "time" }
const _hoisted_12 = { class: "time" }
const _hoisted_13 = { class: "number" }
const _hoisted_14 = { style: {"background":"#842022"} }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"background":"white"} }, "滑动可查看详情"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "down"
  })
], -1)
const _hoisted_17 = { class: "shopNameImgBg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_BigImg = _resolveComponent("BigImg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: "",
      "left-text": "",
      "right-text": "兑换记录",
      onClickLeft: _ctx.onClickLeft,
      onClickRight: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goUrl())),
      class: "title"
    }, null, 8, ["onClickLeft"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coupLists, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "coupList",
          key: index,
          onClick: ($event: any) => (_ctx.jumpInfo(item.couponId))
        }, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(item.subMoney), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(item.couponName), 1),
            _createElementVNode("div", _hoisted_11, " 抢券时间:" + _toDisplayString(item.startTime) + " 10:00 ", 1),
            _createElementVNode("div", _hoisted_12, " 使用时间:" + _toDisplayString(item.useStartTime) + "-" + _toDisplayString(item.useEndTime), 1),
            _createElementVNode("div", _hoisted_13, "余" + _toDisplayString(item.quantity) + "张", 1)
          ])
        ], 8, _hoisted_4))
      }), 128)),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("img", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.showBigImage($event)), ["self"])),
            src: _imports_1,
            alt: ""
          })
        ]),
        _createVNode(_component_BigImg, {
          visible: _ctx.photoVisible,
          url: _ctx.bigImgUrl,
          onCloseClick: _cache[2] || (_cache[2] = 
            () => {
              _ctx.photoVisible = false;
            }
          )
        }, null, 8, ["visible", "url"])
      ])
    ])
  ]))
}